module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-select', {
    style: (_vm.select_style),
    attrs: {
      "disabled": _vm.select_disabled,
      "clearable": "",
      "size": "mini",
      "popper-class": _vm.popper_class,
      "id": _vm.dark ? 'project-is-dark' : '',
      "filterable": ""
    },
    on: {
      "change": _vm.project_change
    },
    model: {
      value: (_vm.current_project_code),
      callback: function($$v) {
        _vm.current_project_code = $$v
      },
      expression: "current_project_code"
    }
  }, _vm._l((_vm.project_options), function(item) {
    return _c('el-option', {
      key: item[_vm.value_field],
      style: (_vm.dark ? {
        backgroundColor: 'black'
      } : {}),
      attrs: {
        "label": item.project_name,
        "value": item[_vm.value_field]
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-7c78f669","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/omnis-business/project-select/project-select.vue
// module id = 85/4
// module chunks = 81